import React, { FunctionComponent, useMemo } from 'react';

import Flex, { FlexProps } from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';

export interface EmbeddedVideoProps extends FlexProps<'div'> {
  src?: string;
  aspectRatio?: number;
}

const useStyles = (aspectRatio: number) => {
  const { breakpoint } = useTheme();

  return useMemo(
    () =>
      ({
        box: {
          alignSelf: 'center',
          width: '100%',
          maxWidth: breakpoint.values.md,
        },
        aspectRatioWrapper: {
          position: 'relative',
          paddingTop: `${aspectRatio * 100}%`,
          width: '100%',
        },
        iframe: {
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '100%',
        },
      } as const),
    [aspectRatio, breakpoint]
  );
};

const EmbeddedVideo: FunctionComponent<EmbeddedVideoProps> = (props) => {
  const { src, aspectRatio = 0.5625, ...other } = props;
  const styles = useStyles(aspectRatio);

  if (!src) {
    return null;
  }
  return (
    <Flex justifyContent="center" margin={[4, 0]} {...other}>
      <Flex css={styles.box}>
        <Flex data-testid="AspectRatioWrapper" css={styles.aspectRatioWrapper}>
          <iframe
            allowFullScreen
            data-testid="EmbeddedIframe"
            css={styles.iframe}
            src={src}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default EmbeddedVideo;
